import React, { useEffect, useState } from "react";
import { gqlType } from "@hifieng/common";
import ScreenLayout from "../ScreenLayout";
import { useOrganizationContext } from "../../contexts/OrganizationProvider";
import Loading from "../Loading";
import FilterContentsSection from "../FilterContentsSection";
import AnalysisFilters from "../FakeLeakAnalysisFilters";
import MobilePageTitle from "../MobilePageTitle";
import EventMap from "../EventMap";
import { getPipelineChKpMap } from "../../helpers/analysisFunctions";
import { SearchRange } from "../../types/AnalysisTypes";

const FakeLeakPage = () => {
  const { activeOrg } = useOrganizationContext();

  const [pipelines, setPipelines] = useState<Array<gqlType.Pipeline>>();
  const [pipeline, setPipeline] = useState<gqlType.Pipeline>();
  const [leakStrength, setLeakStrength] = useState<string>("medium");
  const [globalTestFlag, setGlobalTestFlag] = useState<string>("false");
  const [fiber, setFiber] = useState<gqlType.ChannelKPostMap>();
  const [KPRange, setKPRange] = useState<SearchRange>();

  useEffect(() => {
    if (activeOrg && activeOrg.pipelines) {
      setPipelines((activeOrg && activeOrg.pipelines) || []);
      setPipeline(activeOrg.pipelines[0]);
      setFiber(getPipelineChKpMap(activeOrg.pipelines[0]));
    }
  }, [activeOrg]);

  if (pipelines && pipelines.length && pipeline && fiber) {
    return (
      <ScreenLayout title="Deep Fake Leak">
        <FilterContentsSection
          headerComponent={<MobilePageTitle page="Deep Fake Leak Tool" />}
          filterComponent={
            <AnalysisFilters
              pipelines={pipelines}
              fiber={fiber}
              pipeline={pipeline}
              onPipelineChange={newPipeline => {
                setPipeline(newPipeline);
                setFiber(getPipelineChKpMap(newPipeline));
              }}
              onFiberChange={newFiber => {
                setFiber(newFiber);
              }}
              onLeakStrengthChange={newLeakStrength => {
                setLeakStrength(newLeakStrength);
              }}
              onGlobalTestFlagChange={newGlobalTestFlag => {
                setGlobalTestFlag(newGlobalTestFlag);
              }}
              leakStrength={leakStrength}
              globalTestFlag={globalTestFlag}
              setMapRange={setKPRange}
              KPRange={KPRange}
              singleChannelFlag
            />
          }
          contentComponent={
            <EventMap
              focusPipelines={
                pipeline
                  ? [pipeline.id]
                  : pipelines.length === 1
                  ? [pipelines[0].id]
                  : undefined
              }
              canSearchOnMapMove={false}
              events={[]}
              scrollZoom
              circledRange={KPRange}
            />
          }
        />
      </ScreenLayout>
    );
  }

  return <Loading />;
};

export default FakeLeakPage;
